import {ReduceStore} from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { FSHomePageLightBoxActions } from '../constants/fs_home_page_light_box/fs_home_page_light_box_actions';

class FSHomePageLightBoxStoreClass extends ReduceStore {
    getInitialState() {
        return { visible: false };
    }

    reduce(state, {source, action}) {
        if (source === ACTION_TYPES.FS_HOME_PAGE_LIGHTBOX_ACTION) {
            switch (action.type) {
                case FSHomePageLightBoxActions.SHOW:
                    if (!state.visible) {
                        state.visible = true;
                        this.__emitChange();
                    }

                    break;

                case FSHomePageLightBoxActions.HIDE:
                    if (state.visible) {
                        state.visible = false;
                        this.__emitChange();
                    }

                    break;
            }
        }

        return state;
    }
}

const FSHomePageLightBoxStore = new FSHomePageLightBoxStoreClass(Dispatcher);
export { FSHomePageLightBoxStore };
